module.exports = __webpack_public_path__ + "img/ic-csv.a9b427ce.svg";